module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("二维码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login_container"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.str))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6ff33d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/test/index.vue
// module id = 2397
// module chunks = 1